import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import createAppStore from "./redux/store";
import AppWrapper from "./App/AppWrapper/AppWrapper";
import "@tripian/react/min.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";

// Create the Redux store
const store = createAppStore();

// Get the root container element
const container = document.getElementById("root") as HTMLElement;

// Create the root of the app
const root = createRoot(container);

// Render the app with the Redux Provider and AppWrapper
root.render(
  <Provider store={store}>
    <AppWrapper />
  </Provider>
);

// Register service worker for offline use
serviceWorkerRegistration.register();

// Measure performance if needed
reportWebVitals();
